import type { IntakeRunStatus } from '../types';

/**
 * The pipeline's steps (contract v0.11: Recognize → Read → Extract → Identify → Classify → Map → Verify → Present)
 * shown as the canvas's five visible steps. Identify (the patient check) uses what was just read, so it sits under
 * "Read" (agreed with D1, 16 Oct). An unknown step is shown as it is, with no number.
 */
const VISIBLE_STEP: Record<string, { n: number; label: string }> = {
  Recognize: { n: 1, label: 'Recognize' },
  Read: { n: 2, label: 'Read' },
  Extract: { n: 2, label: 'Read' },
  Identify: { n: 2, label: 'Read' },
  Classify: { n: 3, label: 'Place' },
  Map: { n: 3, label: 'Place' },
  Verify: { n: 4, label: 'Verify' },
  Present: { n: 5, label: 'Review and add' },
};

export function runStatusText(s: IntakeRunStatus | undefined): { label: string; semantic: 'info' | 'success' | 'error' | 'neutral' } {
  if (!s) return { label: 'Queued', semantic: 'neutral' };
  switch (s.status) {
    case 'Queued':
      return { label: 'Queued', semantic: 'neutral' };
    case 'Running': {
      const v = VISIBLE_STEP[s.step];
      return { label: v ? `Reading · step ${v.n} of 5 · ${v.label}` : `Reading · ${s.step}`, semantic: 'neutral' };
    }
    case 'AwaitingReview':
      return { label: 'Ready for review', semantic: 'info' };
    case 'Completed':
      return { label: 'Added', semantic: 'success' };
    case 'Failed':
      return { label: 'Could not be read', semantic: 'error' };
    case 'Discarded':
      return { label: 'Disregarded', semantic: 'neutral' };
    default:
      return { label: s.status, semantic: 'neutral' };
  }
}
